import { SERVICE } from '@src/api/types/shared/serviceType';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import EventFormEditor from '@src/features/tenant/event/EventFormEditor';
import TenantWithoutSideBarLayout from '@src/layouts/tenant/TenantWithoutSideBarLayout';

function EventFormPage() {
  return (
    <TenantRoleGuard
      canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT]}
      canService={[SERVICE.ENTERPRISE_PORTAL]}
    >
      <TenantWithoutSideBarLayout>
        <EventFormEditor />
      </TenantWithoutSideBarLayout>
    </TenantRoleGuard>
  );
}

export default EventFormPage;
